<template>
  <Paginate
    v-bind="$attrs"
    :pageCount="Math.ceil($attrs.total / 40)"
    :firstLastButton="true"
    :firstButtonText="'首页'"
    :lastButtonText="'尾页'"
    :prev-text="'上一页'"
    :next-text="'下一页'"
    :page-class="'item page_num'"
    :prev-class="'item prev_next'"
    :next-class="'item prev_next'"
    :prevLinkClass="'item_a'"
    :nextLinkClass="'item_a'"
    :pageLinkClass="'item_a'"
    :pageCountClass="'page_count'"
    :container-class="'common_pagination'" />
</template>

<script>
import Paginate from './Paginate.vue'

export default {
  name: 'Pagination1',

  components: { Paginate }
}
</script>

<style lang="scss">
.common_pagination { font-size: 0; line-height: 36px; color: #999; text-align: center;
  .item { display: inline-block; height: 36px; font-size: 16px; line-height: 36px; text-align: center; cursor: pointer; border: 1px solid #999; border-radius: 6px;
    &+.item { margin-left: 10px; }
    &.first_last_item { width: 50px; }
    &.active { color: #fff; background-color: $default_primary_color; border-color: $default_primary_color; }
    &:hover { color: #fff; background-color: $default_primary_color; border-color: $default_primary_color; }
  }
  .page_count { display: inline-block; margin-right: 20px; font-size: 16px; }
  .item_a { display: inline-block; width: 100%; height: 100%; outline: none; }
  .page_num { min-width: 36px; }
  .prev_next { width: 68px; }
}
</style>
